import { Swiper } from "swiper";
import { Navigation } from "swiper/modules"

export default function initGallery() {
  const galleryLightbox = document.querySelector(".gallery-lightbox");

  if (!galleryLightbox) return;

  // create swiper slider for lightbox
  const sliderLightbox = new Swiper(
    galleryLightbox.querySelector(".swiper"),
    {
      modules: [Navigation],
      direction: "horizontal",
      freeMode: false,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      navigation: {
        nextEl: galleryLightbox.querySelector(".swiper-button-next"),
        prevEl: galleryLightbox.querySelector(".swiper-button-prev"),
        disabledClass: "disabled",
      },
    }
  );

  const lightboxOpeners = document.querySelectorAll('.gallery-lightbox-open');
  lightboxOpeners.forEach((opener) => {
    opener.addEventListener('click', () => {
      const id = opener.dataset.lightboxId;
      if (!id) return;
      sliderLightbox.slideTo(id);
    })
  })
}